import Header from "../../components/header";
import LeftMenu from "../../components/left-menu";
import Grid from '@mui/material/Grid';
import "./style.css";
import React, {Component} from 'react';
import axios from "axios";
import { useState, useEffect } from 'react';
import TextField from '@mui/material/TextField'; 
import Button from '@mui/material/Button';
import {read} from "../../pages/ListKontrak/api.js";
import {readEmpty} from "../../pages/ListKontrak/apiEmpty.js";
import Post from "../../pages/ListKontrak/Post.jsx";
import {useNavigate} from "react-router-dom";
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import TableBody from '@mui/material/TableBody';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import CloseIcon from '@mui/icons-material/Close';
import EditIcon from '@mui/icons-material/Edit';
import ReceiptIcon from '@mui/icons-material/Receipt';
import LinearProgress from '@mui/material/LinearProgress';
import Box from '@mui/material/Box';
import { endOfDecadeWithOptions } from "date-fns/fp";
import { editableInputTypes } from "@testing-library/user-event/dist/utils";
import { Select, MenuItem, Typography } from '@mui/material';
import { purple } from '@mui/material/colors';
import { styled } from '@mui/material/styles';
import Signature from './Signature';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { MobileDatePicker } from '@mui/x-date-pickers/MobileDatePicker';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import InputAdornment from '@mui/material/InputAdornment';
import { useSelector } from 'react-redux';

export default function CreatePost(){

    const state = useSelector(state => state);

    const [Caption,setCaption] = useState("")
    const [skip, setSkip] = useState(0)
    const [posts, setPosts] = useState([])
    const [isEnd,setIsEnd] = useState("loading..")
    const navigate = useNavigate();
    const [query,setQuery] = useState("")
    const [previewVisibility, setPreviewVisibility] = useState(false)
    const [loadVisibility, setLoadVisibility] = useState(false)
    const [currPreview,setCurrPreview] = useState("none")
   

    useEffect(() => {
        fetchPosts();
        console.log(posts)
    }, [skip,query]);

    async function newKontrak(e){
        history("/create-kontrak",{state:{stuff:"new"}})
    }

    

    const fetchPosts = async () => {
        if(query.trim()){
                try{
                    const { data, error } = await read(skip,query,searchThis);
                    if(error){
                        
                        console.log(error.message);
                        return;
                    }
                    console.log(data.data)

                    if(data.data?.length === 0){
                        setIsEnd("Selesai...");
                        return;
                    }

                    const yoyo = data.data

                    //success
                    setPosts([...posts, ...yoyo])
                }catch(error){
                    console.log(error);
                }
            
        }else{

        try{
            const { data, error } = await readEmpty(skip,query);
            if(error){
                console.log(error.message);
                return;
            }

            if(data?.length === 0){
                setIsEnd("Selesai...");
                return;
            }
            
            //success
            setPosts([...posts, ...data])
        }catch(error){
            console.log(error.message);
        } 
        }
    }

    const [fileURL, setFileURL] = useState("");


    const previewPDF = async (post) => {
        console.log("diatas")
        setCurrPreview(post)
        setLoadVisibility(true)
        const id = post._id
    
        axios.post(`${process.env.REACT_APP_BACKEND_URL}/renderKontrakVOfromDB`,{
           id 
        }, {
            responseType: "blob"
          }).then(resp => {
                    console.log(resp)
                        const blob = new Blob([resp.data], { type: 'application/pdf' })
                    // saveAs(blob);
                    var fileURLNew = URL.createObjectURL(blob);
                    console.log(fileURLNew)
                    setPreviewVisibility(true)
                    setLoadVisibility(false)
                    setFileURL(fileURLNew)
                })
                

            

        
        
        console.log("2")
    
    }

    const newFetchPosts = async (event) => {
        setPosts([])
        setIsEnd("Loading...");
        if(event.target.value.trim()){
        try{
            const { data, error } = await read(skip,event.target.value, searchThis);
            if(error){
                console.log(error.message);
                return;
            }

            if(data.data?.length === 0){
                setIsEnd("Selesai...");
                return;
            }
            const yoyo = data.data
            //success
            setPosts([...yoyo])
        }catch(error){
            console.log(error.message);
        }
        }else{
            console.log("empty")
            try{
                const { data, error } = await readEmpty(skip,event.target.value);
                if(error){
                    console.log(error.message);
                    return;
                }
    
                if(data?.length === 0){
                    setIsEnd("Selesai...");
                    return;
                }
                
                //success
                setPosts([...posts, ...data])
            }catch(error){
                console.log(error.message);
            } 
        }
    }
    const ColorButton = styled(Button)(({ theme }) => ({
        color: theme.palette.getContrastText(purple[500]),
        backgroundColor: purple[500],
        '&:hover': {
          backgroundColor: purple[700],
        },
      }));

    const handleScroll = (e) => {
        const { offsetHeight, scrollTop, scrollHeight } = e.target;

        if(offsetHeight + scrollTop >= scrollHeight){
            setSkip(posts?.length);
        }
    }
    const [searchThis, setsearchThis]= useState("KlienNama");
    const handleSearch = (event) =>{
        setQuery(event.target.value)
        setSkip(0)
        newFetchPosts(event)
    }

    const handleClosePreview = (event) =>{
        setPreviewVisibility(false)
        setCurrPreview("none")
    }

    const testDate = () => {
        const idss= "65b20a15f9600ea4e9c6879c";
        axios.post(`${process.env.REACT_APP_BACKEND_URL}/testingDate`,{
            idss 
         })
    }
    const history = useNavigate();

    const editPI = async (post) => {
        if(currPreview === "none"){
            history("/create-kontrak",{state:{data:post, stuff:"edit"}})
        }else{
            history("/create-kontrak",{state:{data:currPreview, stuff:"edit"}})
        }
    }

    const extend = async (post)=>{
        if(currPreview === "none"){
            history("/create-kontrak", {state:{data:post,stuff:"extend"}})
        }else{
            history("/create-kontrak", {state:{data:currPreview,stuff:"extend"}})
        }
    }

    const [openSignature,setOpenSignature] = useState(false);
    const closeOpenSignature = () => {
        setOpenSignature(false)
    }

    const openSignatureNow = () => {
        setOpenSignature(true)

    }

    const [error,setError]=useState()

    const terminateKontrak = () => {
        if(termintateReason){
             axios.post(`${process.env.REACT_APP_BACKEND_URL}/updateTerminate`, {
                id:currPreview._id,termintateDate,termintateReason
            }).then(() => {
                window.location.reload(); // refresh the page after successful update
            }).catch(error => {
                // handle error
                console.log(error);
            }); 

        }else{
            setError("Ketik Alasan diberhentikan")
        }
    }
    const [termintateDate, setTermintateDate] = useState(new Date())
    const [termintateReason,setTerminatReason] = useState()
    const [openTerminate, setOpenTerminate] = useState(false)

    return <Grid container>
                <Dialog open={openTerminate} onClose={()=>setOpenTerminate(false)}>
                    <Grid xs={12} sx={{p:5}}>
                        <Grid xs={12} container>
                            <Typography>Alasan diberhentikan:</Typography>
                            <TextField value={termintateReason} onChange={(event)=>setTerminatReason(event.target.value)}></TextField>
                        </Grid>
                        <Grid xs={12} sx={{mt:5, mb:5}} container>
                            <Typography>Tanggal diberhentikan:</Typography>
                            <LocalizationProvider dateAdapter={AdapterDateFns}>

                                <MobileDatePicker 
                                    views={['year', 'month', 'day']}
                                    inputFormat="dd/MM/yyyy"
                                    value={termintateDate}
                                    onChange={(event)=>setTermintateDate(event)}
                                    renderInput={(params) => 
                                        <TextField 
                                            {...params} 
                                            InputProps={{
                                                endAdornment: (
                                                    <InputAdornment >
                                                        <CalendarMonthIcon />
                                                    </InputAdornment>
                                                ),
                                            }}
                                        />
                                    }
                                />

                                </LocalizationProvider>
                        </Grid>
                        {error && <Grid className="error_text" sx={{mb:3}}>{error}</Grid>}
                        <Button variant="contained" color="error" onClick={()=>terminateKontrak()}>Berhentikan Kontrak</Button>
                        <Button variant="contained" onClick={()=>setOpenTerminate(false)}>Tidak Jadi / Tutup</Button>


                    </Grid>
                    
                </Dialog>
                <Dialog open={openSignature} onClose={closeOpenSignature}>
                    <Signature currPreview={currPreview} closeOpenSignature={closeOpenSignature}></Signature>
                </Dialog>
                <Dialog open={loadVisibility} aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    sx={{"& .MuiDialog-container": {
                        "& .MuiPaper-root": {
                        width: "100%",
                        maxWidth: "100px",  // Set your width here
                        },
                    },}}>
                    <DialogContent>
                    <Box sx={{ width: '100%' }}>
                        <LinearProgress />
                    </Box>
                    </DialogContent>
                </Dialog>
                <Grid item  xl={0.5} lg={0.7} md={0.9} sm={3.2} className="leftmenucolor">
                    <LeftMenu/>
                </Grid>
                <Grid xl={10.8} lg={10.6} md={10.4} sm={8.8} >
                <Dialog
                    open={previewVisibility}
                    onClose={handleClosePreview}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    sx={{"& .MuiDialog-container": {
                        "& .MuiPaper-root": {
                        width: "100%",
                        maxWidth: "1250px",  // Set your width here
                        },
                    },}}
                                >
                    <DialogTitle id="alert-dialog-title">
                        <Button onClick={handleClosePreview} autoFocus>
                            <CloseIcon></CloseIcon>
                        </Button>
                    </DialogTitle>
                    <DialogContent>
                    <iframe src={fileURL} width="100%" height="500" style={{zoom:"150%"}}/>
                    <DialogContentText id="alert-dialog-description">
                    </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                    <Button variant="contained" color="error" onClick={(event)=>setOpenTerminate(true)} style={{ marginRight: 'auto' }}>
                        Terminate Kontrak
                    </Button>
                    <Button onClick={() => editPI()}>
                        <EditIcon></EditIcon>
                    </Button>
                    <ColorButton variant="contained" onClick={openSignatureNow}>Upload Tanda Tangan</ColorButton>
                    <Button onClick={() => extend()} variant="contained" color="success">
                        Extend
                    </Button>
                    </DialogActions>
                </Dialog>
                <Grid className="boxshadowclass" position="fixed" width="98%" xs={12} zIndex="100" opacity="1">
                    <Header judul="Kontrak" isi="Daftar semua Kontrak"></Header>
                    </Grid>
                    <Grid sx={{ mt:15}}></Grid>
                    <Grid sx={{ pl:15}}>
                    

                            <Grid container>
                            <>
                    {state.user.kontrakcreate==="yes" && (
                    <>
                                <Button onClick={event => newKontrak()}>Create +</Button>
                                </>
  )}
</>
                                <Grid item xs={2}>

  
                            <Select  fullWidth value={searchThis} onChange={event => setsearchThis(event.target.value)}><MenuItem value="KlienNama">Klien</MenuItem><MenuItem value="kontrakAmount">Kode Kontrak</MenuItem><MenuItem value="CompanyName">Company</MenuItem></Select>
                        </Grid>
                                <TextField value={query} onChange={event => handleSearch(event)}></TextField>
                            </Grid>
                            <Grid container align = "center" justify = "center" alignItems = "center">
                            <Paper sx={{ width: '100%', overflow: 'hidden' }}>
                                <TableContainer sx={{ maxHeight: 500, minHeight: 440 }} className="min-h-screen h-screen overflow-scroll" onScroll={handleScroll}>
                                    <Table stickyHeader aria-label="sticky table">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell style={{ width: 200 }}>
                                                    Klien
                                                </TableCell>
                                                <TableCell>
                                                    Company
                                                </TableCell>
                                                <TableCell>
                                                    Tipe Kontrak
                                                </TableCell>
                                                <TableCell>
                                                    Nomor Kontrak
                                                </TableCell>
                                                <TableCell>
                                                    Tanggal Berakhir
                                                </TableCell>
                                                <TableCell>
                                                    Signature
                                                </TableCell>
                                            </TableRow>
                                        </TableHead>
                                        {posts?.map((post) => (
                                            <TableBody>
                                                <TableRow hover sx={{ '&:hover': {
                backgroundColor: '#cceffb !important',
            },backgroundColor: post.statNotify === 'No' ? 'red' : 'white'}}>
                                                    <TableCell onClick={()=> previewPDF(post)} style={{cursor:'pointer'}}>
                                                        <p>{post.KlienNama}</p>
                                                    </TableCell>
                                                    <TableCell onClick={()=> previewPDF(post)} style={{cursor:'pointer'}}>
                                                        <p>{post.CompanyName}</p>
                                                    </TableCell>
                                                    <TableCell onClick={()=> previewPDF(post)} style={{cursor:'pointer'}}>
                                                        <p>{post.TipeKontrak}</p>
                                                    </TableCell>
                                                    <TableCell onClick={()=> previewPDF(post)} style={{cursor:'pointer'}}>
                                                        <p>{post.kontrakAmount}</p>
                                                    </TableCell>
                                                    <TableCell>
                                                    <p>{new Date(post.TanggalBerakhir).toLocaleDateString('id-ID', { day: 'numeric', month: 'long', year: 'numeric' })}</p>
                                                    </TableCell>
                                                    <TableCell onClick={()=> previewPDF(post)} style={{cursor:'pointer'}}>
                                                    <p>{post.signature ? post.signature : 'No'}</p>
                                                    </TableCell>
                                                    
                                                </TableRow>
                                            </TableBody>
                                        ))}
                                        {isEnd}
                                    </Table>
                                </TableContainer>
                            </Paper>
                                
                            </Grid>
                            
                            
                    </Grid>
                </Grid>    
            </Grid>
    };